import "./fesimagnesium.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Fesimagnesium() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731595630/fesimg3_rkttpr.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731595629/fesimg2_ljdufy.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731595630/fesimg1_marawf.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731595629/fesimg2_ljdufy.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Ferrosilicon Magnesium || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Ferro Silicon Magnesium (FeSiMg) is primarily used in the production of ductile iron (also known as spheroidal graphite or nodular cast iron) and has several important applications across various industries."/>
        <meta name="keywords" content="Ferrosilicon Magnesium, Lagos Nigeria" />
		</Helmet>
        <h3>Ferro Silicon Magnesium</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Properties of Our  Ferro Silicon Magnesium:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Improves Ductile Strength of Cast Iron</li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Increases Impact Resistance of Cast Iron
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Improves Wear Resistance of Cast Iron
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Ferro Silicon Magnesium (FeSiMg) is primarily used in the production of ductile iron (also known as spheroidal graphite or nodular cast iron) and has several important applications across various industries.
        </div>
    </div>
  )
}
